import { FilterOption } from '@terminal/components/update-filter-options/updateFilterOptions';
import { generateConditionLabel } from '@terminal/utils/condition-utils/condition-utils';

import styles from './Filter.module.scss';
import type {
  FilterVariant,
  IncludeExcludeLabels,
} from './include-exclude/include-exclude.types';
import { getIncludeExcludeLabel } from './include-exclude/utils/include-exclude.utils';

export type FilterLabelProps = {
  options: FilterOption[];
  multiselect: boolean;
  includedOptions?: FilterOption[];
  excludedOptions?: FilterOption[];
  includeExcludeLabels?: IncludeExcludeLabels;
  variant?: FilterVariant;
};

export const FilterLabel = ({
  options,
  multiselect,
  includedOptions = [],
  excludedOptions = [],
  includeExcludeLabels,
  variant = 'default',
}: FilterLabelProps) => {
  const childNames = options.filter(o => o.childName).map(o => o.name);
  const notChild = (option: FilterOption) => !option.childName;
  const optionCount = options.filter(notChild).length;
  const selectedOption = options.find(notChild);
  const childLabel =
    selectedOption && childNames.length ? `(${childNames.join(' · ')})` : '';

  const displayName = generateConditionLabel(selectedOption) ?? childNames;
  const includeExcludeLabel =
    variant !== 'default' && includeExcludeLabels
      ? getIncludeExcludeLabel({
          includedOptions,
          excludedOptions,
          labels: includeExcludeLabels,
        })
      : undefined;

  return (
    <span className={styles.selectedValue} data-testid="active-filter-label">
      {childLabel && <span>{childLabel}</span>}
      {includeExcludeLabel ? (
        <span>{includeExcludeLabel}</span>
      ) : optionCount > 1 && multiselect ? (
        <span className={styles.countBadge} data-testid="multiselect-count">
          {optionCount}
        </span>
      ) : (
        <span>{displayName}</span>
      )}
    </span>
  );
};
